jQuery(document).ready(function ($) {
    $('.dropdown > a').click(function (e) {
        e.preventDefault();

        let dropdown = $(this).closest(".dropdown");

        dropdown.removeClass( "dropdown-up" );
        $(".dropdown-toggle").removeClass( "dropdown-toggle-rotate" );
        $(".dropdown-toggle").removeClass( "dropdown-toggle-line" );
        if(dropdown.find(".dropdown-menu").hasClass("show_drop_menu")) {
            $(".dropdown-menu").removeClass("show_drop_menu");
            dropdown.find(".dropdown-menu").removeClass("show_drop_menu");
            dropdown.find(".dropdown-toggle").removeClass( "dropdown-toggle-rotate" );
            dropdown.find(".dropdown-toggle").removeClass( "dropdown-toggle-line" );
            dropdown.removeClass( "dropdown-up" );

        } else {
            $(".dropdown-menu").removeClass("show_drop_menu");
            dropdown.find(".dropdown-menu").addClass( "show_drop_menu" );
            dropdown.find(".dropdown-toggle").addClass( "dropdown-toggle-rotate" );
            dropdown.find(".dropdown-toggle").addClass( "dropdown-toggle-line" );
            dropdown.addClass( "dropdown-up" );
        }
    })
    $('.dropdown-toggle').removeAttr( "title" );
    $('.dropdown-item').removeAttr( "title" );
    $('.nav-link').removeAttr( "title" );

    $(document).mouseup(function (e) { // событие клика по веб-документу
        let div = $(".dropdown"); // тут указываем ID элемента
        if (!div.is(e.target) // если клик был не по нашему блоку
            && div.has(e.target).length === 0) { // и не по его дочерним элементам

            $(".dropdown-menu").removeClass("show_drop_menu");
            $(this).find(".dropdown-toggle").removeClass( "dropdown-toggle-rotate" );
            $(this).find(".dropdown-toggle").removeClass( "dropdown-toggle-line" );
            $('.dropdown').removeClass( "dropdown-up" );
        }
    });

    $(".toggle_box").click(function (e) {
        e.preventDefault();

        $('.popup').removeClass('active');

        $(".toggle_box").hide();
        $(".cross").show();
        $("#main-header").addClass('opened');
        $('body').css({overflow: 'hidden'});
    });
    $(".cross").click(function (e) {
        e.preventDefault();

        $(".cross").hide();
        $(".toggle_box").show();
        $("#main-header").removeClass('opened');
        $('body').css({overflow: 'unset'});
    });

    $(".js-header-find-room").click(function (e) {
        $(".cross").hide();
        $(".toggle_box").show();
        $("#main-header").removeClass('opened');
        $('body').css({overflow: 'unset'});
    });
});

